__turbopack_context__.v({
  "faqContainer": "ohkE0W_faqContainer",
  "faqHeader": "ohkE0W_faqHeader",
  "faqsInner": "ohkE0W_faqsInner",
});
